export enum SortValues {
  CategoryAsc = 'category_asc',
  CategoryDesc = 'category_desc',
  DistanceAirport = 'distance_airport', // only DP
  DistanceCity = 'distance_city_centre', // only for cities, not for tags
  Fastest = 'fastest',
  HotelCategory = 'hotelcategory',
  NearestDeparture = 'nearest_departure_date', // only for Flexible dates
  Price = 'price',
  PriceAsc = 'price_asc',
  PriceDesc = 'price_desc',
  Recommended = 'recommended',
  Stars = 'stars',
  TopReviewed = 'top_reviewed',
}
